// action
import {
    GET_TESTIMONIAL_LIST,
    GET_TESTIMONIAL_LIST_FAIL,
    GET_TESTIMONIAL_LIST_SUCCESS,
    GET_TESTIMONIAL_LIST_RESET
} from '../action/getTestimonialListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TESTIMONIAL_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_TESTIMONIAL_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_TESTIMONIAL_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data,
            }
        case GET_TESTIMONIAL_LIST_RESET:
            return initialState
        default:
            return state
    }
}